import { CancellationReason } from "@/domain/entities/CancellationReason";
import { CancellationReasonDataResponseDTO } from "../dto/CancellationReasonListResponseDTO";

const toEntity = (data: CancellationReasonDataResponseDTO): CancellationReason => {
    return {
        subscription_type: data?.subscription_type?.toLowerCase(),
        reason_for_cancellation: data?.reason_for_cancellation || "",
        user: {
            id: data?.user?.id || "",
            name: data?.user?.name || "",
            email: data?.user?.email || "",
        },
        created_at: data?.created_at || "",
    };
};

export default { toEntity };
